import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LoginModal from "./auth/LoginModal";
import SignupModal from "./auth/SignupModal";
import { fetchCategorySummaries } from "./services/apiService";
import DynamicPageWrapper from "./components/DynamicPageWrapper";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WishlistPage from "./components/WishlistPage";
import UserLocationMap from "./pages/UserLocationMap";
import LocationTrackerMap from "./pages/LocationTrackerMap";
import DriverPortal from "./pages/DriverPortal";
import DriverBookingPortal from "./pages/DriverBookingPortal";
import TransportOwnerPortal from "./pages/TransportOwnerPortal";
import PublicTrackingPage from "./pages/PublicTrackingPage";
import HotelBookingConfirmationPage from "./pages/HotelBookingConfirmationPage";
import LeadTeamPortal from "./pages/LeadTeamPortal";
import HotelImagesPage from "./pages/HotelImagesPage";
import HotelAvailabilityPage from "./pages/HotelAvailabilityPage";
import ChatsPage from "./pages/ChatsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/theme.css";
import "./styles/staff-dark.css";
import AdminDashboard from "./admin/AdminDashboard";
import AdminGate from "./admin/AdminGate";
import HotelAvailabilityAdmin from "./admin/HotelAvailabilityAdmin";
import HotelOwnerPortal from "./admin/HotelOwnerPortal";

document.addEventListener(
  "wheel",
  (event) => {
    const activeElement = document.activeElement;
    if (
      activeElement instanceof HTMLInputElement &&
      activeElement.type === "number"
    ) {
      event.preventDefault();
    }
  },
  { passive: false }
);

// Only the public site (homepage, menu, trip pages) shows the trip list; admin and the portals
// never load it.
const showsTripList = (pathname) => pathname === "/" || pathname.startsWith("/trips/");

const RootComponent = () => (
  <Auth0Provider
    domain="dev-kl3meji5hz28y376.us.auth0.com"
    clientId="GNmW9JWeGX8x2iTVBsZeYbPc7slHeLOy"
    authorizationParams={{ redirect_uri: window.location.origin }}
  >
    <Router>
      <AppRoutes />
    </Router>
  </Auth0Provider>
);

const AppRoutes = () => {
  const { pathname } = useLocation();
  const [categories, setCategories] = useState([]);
  const categoriesRequested = useRef(false);

  useEffect(() => {
    if (categoriesRequested.current || !showsTripList(pathname)) return;
    categoriesRequested.current = true;
    fetchCategorySummaries()
      .then(setCategories)
      .catch(() => {
        categoriesRequested.current = false;
      });
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<App categories={categories} />} />
      <Route path="/login" element={<LoginModal />} />
      <Route path="/signup" element={<SignupModal />} />
      <Route
        path="/trips/:tripPath"
        element={<DynamicPageWrapper categories={categories} />}
      />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/location" element={<UserLocationMap />} />
      <Route path="/locationtrack" element={<LocationTrackerMap />} />
      <Route path="/driver" element={<DriverPortal />} />
      <Route path="/driver/booking/:token" element={<DriverBookingPortal />} />
      <Route path="/driver/:accessKey" element={<DriverPortal />} />
      <Route path="/transport-owner/:accessKey" element={<TransportOwnerPortal />} />
      <Route path="/tracking/:token" element={<PublicTrackingPage />} />
      <Route path="/hotel-booking-confirmation/:token" element={<HotelBookingConfirmationPage />} />
      <Route
        path="/admin"
        element={
          <AdminGate>
            <AdminDashboard />
          </AdminGate>
        }
      />
      <Route
        path="/admin/chats"
        element={
          <AdminGate>
            <ChatsPage scope="ADMIN" />
          </AdminGate>
        }
      />
      <Route
        path="/hoteladmin"
        element={
          <AdminGate>
            <HotelAvailabilityAdmin />
          </AdminGate>
        }
      />
      <Route path="/hotelportal/:accessKey" element={<HotelOwnerPortal />} />
      <Route path="/call-team" element={<LeadTeamPortal team="CALL" />} />
      <Route path="/chat-team" element={<LeadTeamPortal team="CHAT" />} />
      <Route path="/call-team/hotel-images" element={<HotelImagesPage team="CALL" />} />
      <Route path="/chat-team/hotel-images" element={<HotelImagesPage team="CHAT" />} />
      <Route path="/call-team/hotel-availability" element={<HotelAvailabilityPage team="CALL" />} />
      <Route path="/chat-team/hotel-availability" element={<HotelAvailabilityPage team="CHAT" />} />
      <Route path="/call-team/chats" element={<ChatsPage scope="CALL" />} />
      <Route path="/chat-team/chats" element={<ChatsPage scope="CHAT" />} />
    </Routes>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <RootComponent />
    <ToastContainer position="top-right" autoClose={3000} newestOnTop />
  </>
);
reportWebVitals();

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
